import classes from '@/components/Shares/Pagination.module.css';
import { ChunkArray } from '@/helpers/ChunkArray';
import { Group, Pagination, SimpleGrid, Stack } from '@mantine/core';
import { useState } from 'react';
import { BlogCard } from './BlogCard';
import { BlogFilter } from './BlogFilter';
import { blogs } from './blogs';
const data = ChunkArray(blogs, 9);
export const BlogNews: React.FC = () => {
  const [activePage, setPage] = useState(1);
  const posts = data[activePage - 1].map(item => <BlogCard key={item.id} {...item} />);
  return <Stack align="center" mt={{
    base: 16,
    sm: 32,
    lg: 40
  }}>
      <BlogFilter />

      <SimpleGrid cols={{
      base: 1,
      sm: 2,
      lg: 3
    }} spacing={20} mt={{
      sm: 16,
      lg: 24
    }}>
        {posts}
      </SimpleGrid>

      <Pagination.Root total={data.length} value={activePage} onChange={setPage} my={40} classNames={classes}>
        <Group gap={5} justify="center">
          <Pagination.Previous />
          <Pagination.Items />
          <Pagination.Next />
        </Group>
      </Pagination.Root>
    </Stack>;
};